export default "__VITE_ASSET__BBkR_4sZ__"